import React from 'react'
import styles from "../styles/Stands.module.css"
import Value from "../img/Value.svg"
import enchance from "../img/Enchance.svg"
import realise from "../img/realisation.svg"

const Stands = () => {
  return (
    <div className={styles.stands_cont}>
        <h1>What Relico Ventures Stands For</h1>
        <p>Our core philosophy is built on three fundamental pillars that drive every  engagement</p>
        <div className={styles.stands_grid}>
            <div className={styles.stand_grid1}>
                <div>
                    <img src={Value} alt="value-logo" />
                </div>
                <h2>Value Creation</h2>
                <p>We identify and develop new opportunities, helping organizations unlock untapped potential and create sustainable competitive advantages.</p>
            </div>
            <div className={styles.stand_grid1}>
                <div>
                    <img src={enchance} alt="enchance" />
                </div>
                <h2>Value Enhancement</h2>
                <p>Through strategic optimization and operational excellence, we strengthen existing business models and enhance overall organizational performance.</p>
            </div>
            <div className={styles.stand_grid1}>
                <div>
                    <img src={realise} alt="realise" />
                </div>
                <h2>Value Realization</h2>
                <p>We ensure tangible results by implementing actionable strategies that deliver measurable outcomes and long-term value for stakeholders.</p>
            </div>
        </div>
    </div>
  )
}

export default Stands